import { BaseSelectMenu } from "~/components/Form/components/SelectMenu/BaseSelectMenu/BaseSelectMenu";
import { useSelectMenu } from "./hooks/useSelectMenu";
import { Props as AutocompleteProps } from "~/components/Form/components/SelectMenu/AutocompleteField";
import { BaseSelectMenuList } from "~/components/Form/components/SelectMenu/BaseSelectMenu/BaseSelectMenuList";

type SelectMenuVariant = "plain" | "checkbox";

export type Option = {
  label: string;
  value: string;
};

export type GroupedOption = {
  groupLabel: string;
  options: Option[];
};

type SingleSelectProps = {
  multiple?: false;
  value: string;
};

type MultiSelectProps = {
  multiple: true;
  value: string[];
};

export type OptionsProps = GroupedOption[] | Option[];

type BaseSelectProps = {
  isOpen: boolean;
  onClose: () => void;
  variant: SelectMenuVariant;
  anchorRef: HTMLElement | null;
  options: OptionsProps;
  autocomplete?: AutocompleteProps;
  onChange: (value: string | string[]) => void;
  maxHeight?: number;
  error?: boolean;
  helperText?: string;
};

export type Props = BaseSelectProps & (SingleSelectProps | MultiSelectProps);

export const SelectMenu = (props: Props) => {
  const {
    anchorRef,
    isOpen,
    autocomplete,
    onClose,
    maxHeight,
    error,
    helperText,
  } = props;

  const { renderMenuItems } = useSelectMenu(props);

  return (
    <BaseSelectMenu
      showKeyboardHint
      isOpen={isOpen}
      autocomplete={autocomplete}
      onClose={onClose}
      anchorRef={anchorRef}
      error={error}
      helperText={helperText}
      renderContent={() => (
        <BaseSelectMenuList sx={{ mt: 2, maxHeight }}>
          {renderMenuItems()}
        </BaseSelectMenuList>
      )}
    />
  );
};
